import React, { Component } from 'react';

export default class KlarnaCheckout extends Component {
  componentDidMount() {
    let { checkout } = this.props;

    // @see: https://developers.klarna.com/en/gb/kco-v3/checkout/2-render-the-checkout/
    this.element.innerHTML = checkout.html_snippet;
    var scriptsTags = this.element.getElementsByTagName('script');

    // This is necessary otherwise the scripts tags are not going to be evaluated
    for (var i = 0; i < scriptsTags.length; i++) {
      var parentNode = scriptsTags[i].parentNode;
      var newScriptTag = document.createElement('script');
      newScriptTag.type = 'text/javascript';
      newScriptTag.text = scriptsTags[i].text;
      parentNode.removeChild(scriptsTags[i]);
      parentNode.appendChild(newScriptTag);
    }
  }

  render() {
    return <div ref={ref => (this.element = ref)} />;
  }
}
